import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Underline = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0072 5.03125H15.5V13.3218C15.5 13.8878 15.4791 14.3915 15.2301 14.8329C14.9848 15.2706 14.6302 15.6159 14.1661 15.8687C13.702 16.1177 13.1473 16.2422 12.5021 16.2422C11.8569 16.2422 11.3023 16.1177 10.8382 15.8687C10.3779 15.6159 10.0232 15.2706 9.77419 14.8329C9.52517 14.3915 9.5 13.8878 9.5 13.3218V5.03125H7.99707V13.6744C7.99707 14.4668 8.18195 15.1743 8.55171 15.7968C8.92525 16.4156 9.44971 16.9042 10.1251 17.2627C10.8005 17.6173 11.5928 17.7947 12.5021 17.7947C13.4114 17.7947 14.2038 17.6173 14.8792 17.2627C15.5546 16.9042 16.0771 16.4156 16.4469 15.7968C16.8204 15.1743 17.0072 14.4668 17.0072 13.6744V5.03125ZM18.0002 19.5312H7.00024V21H18.0002V19.5312Z"
        fill={color}
      />
    </svg>
  )
})

export default Underline
